import * as ax from "axios";
import config from "../config";

class axios {
  static instance = null;
  static getInstance() {
    if (!axios.instance) {
      axios.instance = ax.create({
        baseURL: config("API_HOST")
      });
    }
    return axios.instance;
  }
}

export default axios.getInstance();
